export default __webpack_public_path__ + "dd660016ebe9e721659cfd3870507100.svg";